<template>
  <AiChat :open="visible" ref="aiChat" :quote="quote" @on-close="cancelHandler" @on-insert="onInsert"  :title="nodeDetail && nodeDetail.id ? '编辑采集节点' : '增加采集节点'">
    <div class="content">
      <Form :model="formData" class="form-content" ref="form" :label-width="110" :rules="ruleValidate">
        <FormItem label="节点名称" prop="name">
          <Input v-model="formData.name" placeholder="" />
        </FormItem>
        <form-item-voices
          label="话术文本"
          v-model="formData.voices"
          :formItemProps="{
            rules: {required: true, message: '话术文本不能为空', trigger: 'blur'},
          }"
          @openAi="(index) => {
            openAi('voice', index)
          }"
        />
        <FormItem label="采集规则" prop="collect_rule">
          <Input
            palceholder="请输入采集规则"
            v-model="formData.collect_rule"
            placeholder="空时匹配全部"
          />
        </FormItem>
        <FormItem
          label="采集到变量"
          prop="collect_field_name"
          :rules="{required: true, message: '采集到变量不能为空'}"
        >
          <Select v-model="formData.collect_field_name">
            <Option v-for="item in vars" :value="item.name" :key="item.name">{{
              item.name
            }}</Option>
          </Select>
        </FormItem>
        <form-item-voices
          label="采集确认结束语"
          v-model="formData.collect_confirm_voices"
          @openAi="(index) => {
            openAi('confirm_voice', index)
          }"
        />
        <form-item-keyword
          :formItemProps="{
            label: '采集确认关键词',
            prop: 'collect_confirm_sentences',
          }"
          v-model="formData.collect_confirm_sentences"
          @open-ai="() => {
            openAi('confirm_keyword')
          }"
        />
        <form-item-keyword
          :formItemProps="{
            label: '采集否定关键词',
            prop: 'collect_refuse_sentences',
          }"
          v-model="formData.collect_refuse_sentences"
          @open-ai="() => {
            openAi('refuse_keyword')
          }"
        />
        <!-- 是否支持打断 -->
        <form-item-can-break :formItemProps="{ prop: 'can_break' }" v-model="formData.can_break"/>
        <FormItem label="前">
          <InputNumber v-model="formData.break_delay" :min="0" :disabled="!formData.can_break"/><span style="margin-left: 5px">ms不打断</span>
        </FormItem>
        <FormItem label="延迟播放">
          <InputNumber v-model="formData.playback_delay" :min="0" /><span style="margin-left: 5px">ms</span>
        </FormItem>
        <FormItem label="协同提醒">
          <div>
            <i-switch v-model="formData.hmc_remind"/>
            <span style="margin-left: 15px;" v-if="formData.hmc_remind">
              <SkillSelect v-model="formData.hmc_skill_id" v-if="access.userSkill"/>
            </span>
          </div>
        </FormItem>
        <FormItem label="说完转接">
          <i-switch v-model="formData.hmc_after_play" :disabled="!formData.hmc_remind"/>
        </FormItem>
        <FormItem label="启用按键">
          <i-switch v-model="formData.enable_dtmf"/>
        </FormItem>
        <FormItem label="收号长度">
          <InputNumber v-model="formData.dtmf_digits_length" :min="0" placeholder="收号长度 0-不限制" :disabled="!formData.enable_dtmf" />
        </FormItem>
        <FormItem label="收号终止字符" prop="dtmf_terminator">
          <Input v-model="formData.dtmf_terminator"  :disabled="!formData.enable_dtmf"/>
        </FormItem>
        <FormItem label="等待响应超时时长">
          <InputNumber v-model="formData.input_timeout" :min="0" /><span style="margin-left: 5px">ms</span>
        </FormItem>
        <FormItem label="播放超时语音">
          <i-switch :value="!formData.no_timeout_voice" @on-change="formData.no_timeout_voice = !$event"/>
        </FormItem>
        <!-- 自定义标签 -->
        <form-item-tag :formItemProps="{ prop: 'tag' }" v-model="formData.tag"/>
        <!-- 变量操作 -->
        <form-item-var :formItemProps="{ prop: 'vars' }" v-model="formData.vars"/>
      </Form>
      <div class="btn">
        <Button style="margin-right: 20px" color="#547ed1" @click="cancelHandler">取消</Button>
        <Button
          type="primary"
          style="margin-right: 20px"
          color="#547ed1"
          @click="submit"
        >
          确定
        </Button>
      </div>
    </div>
  </AiChat>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'
import FormItemTag from '@/components/FormItemTag.vue';
import FormItemVar from '@/components/FormItemVar.vue';
import FormItemVoices from '../../../components/FormItemVoices.vue';
import FormItemCanBreak from '../../../components/FormItemCanBreak.vue';
import FormItemKeyword from '../../../components/FormItemKeyword.vue';
import SkillSelect from '../../../components/SkillSelect.vue';
import { addNodeId } from '@/utils/nodeIdPool';
import { mapState } from 'vuex';
import AiChat from '@/views/aiChat/index'

export default {
  components: {
    FormItemTag,
    FormItemVar,
    FormItemVoices,
    FormItemCanBreak,
    FormItemKeyword,
    SkillSelect,
    AiChat
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    nodeDetail: {
      type: Object,
    }
  },
  data() {
    const validatedtmfTerminator = (rule, value, callback) => {
        if(value === '') {
          callback()
        } else if (value.lenth > 1) {
            callback(new Error('只支持1位'))
        } else if (!['0','1','2','3','4','5','6','7','8','0','*','#'].includes(value)) {
            callback(new Error('只支持0-9、*、#'))
        } else {
            callback()
        }
    }
    return {
      title: '',
      formData: {
        name: '',
        can_break: true,
        break_delay: 0,
				playback_delay: 0,
        hmc_remind: false,
        hmc_skill_id: '',
        hmc_after_play: false,
        input_timeout: 0,
        no_timeout_voice: false,
        collect_field_name: '',
        collect_rule: '',
				tag: '',
        voices: [{ voice: '', text: '', id: addNodeId('V') }], // 录音
				vars: [],
        collect_confirm_voices: [{ voice: '', text: '', id: addNodeId('V') }],
        collect_confirm_keywords: '',
        collect_confirm_sentences: [],
        collect_refuse_keywords: '',
        collect_refuse_sentences: [],
        enable_dtmf: false, // 是否启用按键
        dtmf_digits_length: 0, // 收号长度 0-不限制
        dtmf_terminator: '', // 收号终止字符
      },
      insertConf: {
        type: '',
        index: 0,
      },
      quote: null,
      ruleValidate: {
        name: [
          { required: true, message: '节点名不能为空', trigger: 'blur' },
        ],
        dtmf_terminator: [
          { validator: validatedtmfTerminator },
        ],
      }
    };
  },
	watch: {
		nodeDetail(val) {
			if (!val) {
        this.resetFormData();
        return;
      }
      this.formData = {
        ...this.formData,
        ...cloneDeep(val)
      }
		}
	},
  computed: {
    ...mapState('setting', ['vars']),
    ...mapState('user', ['access']),
  },
  methods: {
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        const formData = {
          ...cloneDeep(this.formData),
          hmc_skill_id: this.formData.hmc_remind ? this.formData.hmc_skill_id : '',
          type: 'collect',
        }
        formData.collect_confirm_voices = formData.collect_confirm_voices.filter(item => item.text || item.voice);
        if(this.formData.id) {
          this.$emit('editNode', formData)
        } else {
          this.$emit('addNode', formData)
        }
        this.cancelHandler();
      })
    },
    cancelHandler() {
      try {
        this.resetFormData();
      } catch (error) {
        // 改成多段录音后 form.resetFields 后报错
        console.log('error :>> ', error);
      }
      this.$emit('change', false)
      this.$emit('cancel')
      this.quote = null
      this.insertConf = {
        type: '',
        index: 0,
      }
    },
    resetFormData() {
      this.$refs.form.resetFields()
      this.formData = {
        name: '',
        can_break: true,
        break_delay: 0,
				playback_delay: 0,
        hmc_remind: false,
        hmc_skill_id: '',
        hmc_after_play: false,
        input_timeout: 0,
        no_timeout_voice: false,
        collect_field_name: '',
        collect_rule: '',
				tag: '',
        voices: [{ voice: '', text: '', id: addNodeId('V') }], // 录音
				vars: [],
        collect_confirm_voices: [{ voice: '', text: '', id: addNodeId('V') }],
        collect_confirm_keywords: '',
        collect_refuse_keywords: '',
        collect_confirm_sentences: [],
        collect_refuse_sentences: [],
        enable_dtmf: false, // 是否启用按键
        dtmf_digits_length: 0, // 收号长度 0-不限制
        dtmf_terminator: '', // 收号终止字符
      }
    },
    openAi(type, index) {
      this.insertConf = {
        type,
        index
      }
      console.log(type, index)
      if (type === 'voice') {
        const text = this.formData.voices[index] && this.formData.voices[index].text
        this.quote = {
          type: 'aichat.hint',
          name: `${this.formData.name}-语音${~~index + 1}`,
          workId: 'OPTIMIZE_CALL_SCRIPT',
          hint: `节点名称:${this.formData.name}\n节点文本:${text}`
        }
      } else if (type === 'confirm_voice') {
        const text = this.formData.collect_confirm_voices[index] && this.formData.collect_confirm_voices[index].text
        this.quote = {
          type: 'aichat.hint',
          name: `${this.formData.name}-语音${~~index + 1}`,
          workId: 'OPTIMIZE_CALL_SCRIPT',
          hint: `节点名称:${this.formData.name}\n节点文本:${text}`
        }
      } else if (type === 'confirm_keyword') {
        this.quote = {
          type: 'aichat.hint',
          name: `${this.formData.name}-确认关键词`,
          workId: 'GENERALIZED_KEYWORDS',
          variables: {
            matching_content: formData.name,
            keywords: (formData.collect_confirm_sentences || []).join(',')
          }
        }
      } else if (type === 'refuse_keyword') {
        this.quote = {
          type: 'aichat.hint',
          name: `${this.formData.name}-否定关键词`,
          workId: 'GENERALIZED_KEYWORDS',
          variables: {
            matching_content: formData.name,
            keywords: (formData.collect_refuse_sentences || []).join(',')
          }
        }
      }
      setTimeout(() => {
        this.$refs.aiChat.sendMessage('文案优化')
      }, 100)
    },
    onInsert(text) {
      const { type, index } = this.insertConf
      if (type === 'voice') {
        this.formData.voices[index].text = text;
      } else if (type === 'confirm_voice') {
        this.formData.collect_confirm_voices[index].text = text;
      } else if (type === 'confirm_keyword') {
				const sentences = this.formData.collect_confirm_sentences
				sentences.push(...text.split(/[,，]/))
				this.formData.collect_confirm_sentences = [...new Set(sentences)]
      } else if (type === 'refuse_keyword') {
				const sentences = this.formData.collect_refuse_sentences
				sentences.push(...text.split(/[,，]/))
				this.formData.collect_refuse_sentences = [...new Set(sentences)]
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.form-content {
  overflow-y: auto;
  flex: 1;
}
.btn {
  width: 100%;
  background: #fff;
  padding: 10px 16px;
  text-align: right;
	border-top: 1px solid #e8e8e8;
}
.vars-header {
	display: flex;
	justify-content: space-between;
	margin-bottom: 10px;
}
.var-line {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
}
.var-form {
	flex: 1;
}
.var-del-icon {
	margin-left: 10px;
	font-size: 16px;
}
</style>